import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore.js';
import BrandLoading from '../ui/BrandLoading.jsx';
import { useVisibleLoading } from '../../hooks/useVisibleLoading.js';

export default function ProtectedRoute({ children }) {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const initialized = useAuthStore((s) => s.initialized);
  const location = useLocation();
  const showLoading = useVisibleLoading(!initialized, 400);

  if (showLoading) {
    return <BrandLoading variant="fullscreen" label="Verificando sesión…" />;
  }

  if (!token || !user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
